var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 230.19 301.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9e9e9f;}.cls-2{fill:#343231;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.72,229.42H82.94a129.06,129.06,0,0,1-38.61,27.36s9.1,34,12,44.71c0,0,103.56-16.49,163-86.49l-13.86-8.41A126.56,126.56,0,0,1,132.72,229.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 230.19,
    height: 230.19,
    rx: 44.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.13,80.51a4.28,4.28,0,0,0,2.81,1.9c12,3.12,35.63-.86,37.56-16,.31-2.49-1-8.53-4.53-5.66-3.75,3-6.32,7.23-10.19,10.2a20.12,20.12,0,0,1-13.06,4.34c-3.12-.11-6.52-.8-9.58.15C49.39,76.28,48.13,78.7,49.13,80.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.4,80.51a4.31,4.31,0,0,1-2.82,1.9c-12,3.12-35.62-.86-37.55-16-.32-2.49,1-8.53,4.52-5.66,3.76,3,6.32,7.23,10.2,10.2a20.11,20.11,0,0,0,13.05,4.34c3.13-.11,6.52-.8,9.58.15C180.14,76.28,181.4,78.7,180.4,80.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84,98.69c2.61.37,5,1.74,7.21,3.08,3,1.76,6,3.62,7.85,6.55.83,1.35,1.31,3.21.31,4.45a4.09,4.09,0,0,1-2.86,1.2c-7.25.69-14.36-4.49-21.45-2.84-3.05.71-19,8.7-14.36-.6C63.93,104,77.18,97.73,84,98.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.55,98.69c-2.61.37-5,1.74-7.22,3.08-3,1.76-6,3.62-7.84,6.55-.83,1.35-1.31,3.21-.31,4.45A4.09,4.09,0,0,0,133,114c7.24.69,14.35-4.49,21.45-2.84,3,.71,19,8.7,14.36-.6C165.6,104,152.35,97.73,145.55,98.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.15,168.58c-.68-14.19,12-24.48,22.37-32,4.69-3.4,9.55-7.85,15.54-8.71,6.76-1,12.28,3.94,16.47,8.62a122.39,122.39,0,0,1,11.79,15.4c3.69,5.71,6.94,13,3.85,19.05-2.4,4.68-8,7-13.25,7.08s-10.38-1.51-15.49-2.74a34.54,34.54,0,0,0-12.16-1,23.18,23.18,0,0,0-6,1.58c-2,.83-3.71,2.06-5.72,2.8a15.19,15.19,0,0,1-11-.13,10.37,10.37,0,0,1-6.24-8.46C79.22,169.61,79.17,169.09,79.15,168.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M176,134.93c.52,3.25,2,7,4.7,9a6.07,6.07,0,0,0,8-.77c3.17-3.32,1.94-8.64.46-12.43-1.8-4.59-5.11-9.23-9.76-11.24a10.31,10.31,0,0,0-7.15-.46c-2.09.64-.91,2.61-.14,3.87a26.33,26.33,0,0,1,3,7.23C175.57,131.72,175.76,133.33,176,134.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.17,134.93c-.52,3.25-2,7-4.7,9a6.07,6.07,0,0,1-8-.77c-3.17-3.32-1.94-8.64-.46-12.43,1.8-4.59,5.11-9.23,9.76-11.24a10.31,10.31,0,0,1,7.15-.46c2.09.64.91,2.61.14,3.87a26.33,26.33,0,0,0-3,7.23C54.62,131.72,54.43,133.33,54.17,134.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.1c8598a4a5d792db81e5d7bbba4bb043.svg";
export { ForwardRef as ReactComponent };